<template>
  <div class="h-full flex flex-column">
    <div class="m-16px flex-1 flex flex-column">
      <Tabs :datas="{'AssetsList':'固定资产管理','AssetsChange':'变更及生成凭证','AssetsDepreciationDetails':'计提折旧及生成凭证'}" class="px-20px bg-white-color" v-model="tab"/>
      <Component :is="tab" class="flex-1 flex flex-column"></Component>
    </div>
  </div>
</template>

<script>/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import AssetsList from "@/views/assets/AssetsList";
import AssetsChange from "@/views/assets/AssetsChange";
import AssetsDepreciationDetails from "@/views/assets/AssetsDepreciationDetails";

export default {
  name: "Assets",
  components: {AssetsList, AssetsChange, AssetsDepreciationDetails},
  data() {
    return {
      tab: "AssetsList",
      loading: false,
    }
  },
}
</script>
